import React from 'react'

import {ROUTES} from 'constants/routes.constant'

const authRoute = [
    {
        key: 'signIn',
        path: ROUTES.SIGN_IN,
        component: React.lazy(() => import('views/auth/SignIn')),
    },
    {
        key: 'forgotPassword',
        path: ROUTES.FORGOT_PASSWORD,
        component: React.lazy(() => import('views/auth/ForgotPassword')),
    },
    {
        key: 'setNewPassword',
        path: ROUTES.SET_NEW_PASSWORD,
        component: React.lazy(() => import('views/auth/ResetPassword')),
    },
    {
        key: 'createPassword',
        path: ROUTES.CREATE_PASSWORD,
        component: React.lazy(() => import('views/auth/CreatePassword')),
    },
    {
        key: 'expiredLink',
        path: ROUTES.EXPIRED_LINK,
        component: React.lazy(() => import('views/auth/ExpiredLink')),
    },
]

export default authRoute
